<script>
import LinksMixin from "../../../author/pagesbuilder/mixins/LinksMixin";
import AlignmentMixin from "../../../author/pagesbuilder/mixins/AlignmentMixin";
import {mapState} from "vuex";

function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes*60000);
}

function newLocalizedDate() {
    return new Date(LWTranslate.formatTimestampLocalized(new Date().getTime()/1000, "YYYY-MM-DDTHH:mm:ss"));
}

export default {
    name: "TimerComponent",
    mixins: [LinksMixin, AlignmentMixin],
    data() {
        return {
            // Learnworlds framework data
            rendersWithVue: true,
            componentType: "timer",

            // Private instance data
            timerStyleClasses: ['timer1', 'timer2', 'timer3', 'timer4', 'timer5', 'timer6', 'timer7', 'timer8', 'timer9', 'timer10'],
            miniTimerStyleClasses: ['minitimer1', 'minitimer2', 'minitimer3', 'minitimer4', 'minitimer5', 'minitimer6', 'minitimer7', 'minitimer8', 'minitimer9', 'minitimer10'],
            registeredInterval: null, // Used by clearInterval
            hasStarted: false,
            hasFinished: false,
            secondsLeft: 0,
            units: {
                days: {value: 0, divisor: 24*60*60},
                hours: {value: 0, divisor: 60*60},
                minutes: {value: 0, divisor: 60},
                seconds: {value: 0, divisor: 1},
            },
            alignmentClass: "",
        }
    },
    computed: {
        // Needed to get the unique page id for local storage
        ...mapState("pages", [
            "pageData"
        ]),
        hasElementAddButton () {
            return {};
        },
        getDefaultDataStructure() {
            return {
                componentType: this.componentType,
                componentId: this.componentId,
                responsiveAlignmentClass: {
                    'desktop': '',
                    'tablet-portrait': '',
                    'tablet-landscape': '',
                    'smartphone-portrait': '',
                    'smartphone-landscape': ''
                },
                unitsShown: {
                    days: true,
                    hours:  true,
                    minutes: true,
                    seconds: true,
                },
                timerStyleClass: this.getInitialTimerStyleClass(),
                timerType: "dateCountdown",
                startTime: newLocalizedDate(),
                endTime: addMinutes(newLocalizedDate(), 120),
                perVisitorMinutes: 300,
                finishAction: "message",
                message: "Countdown ended",
                hideIfInactive: false,
            }
        },
        hidden() {
            return (!this.hasStarted && this.hideIfInactive) || (this.hasFinished && this.finishAction === "hide");
        },
        filteredUnitsShown() {
            if (this.unitsShown) {
                return Object.keys(this.units).filter(u => this.unitsShown[u]);
            } else {
                return [];
            }
        },
        timerStyleClass() {return this.getTimerStyleClass() },
        timerType() { return this.getTimerType() },
        unitsShown() {return this.getUnitsShown() },
        startTime() { return this.getStartTime() },
        endTime() { return this.getEndTime() },
        perVisitorMinutes(){return this.getPerVisitorMinutes() },
        finishAction() { return this.getFinishAction() },
        message() {return this.getMessage() },
        hideIfInactive() { return this.getHideIfInactive() },
    },
    methods: {
        timerTick() {
            let currentTime = newLocalizedDate();
            this.hasStarted = currentTime >= this.startTime;
            this.hasFinished = currentTime > this.endTime;

            // If timer hasn't begun yet. Populate units from start date
            let fromTimeToCalc = !this.hasStarted ? this.startTime : currentTime;

            // If start more then end, all zeros
            fromTimeToCalc = this.startTime > this.endTime ? this.endTime : fromTimeToCalc;

            if(!this.hasFinished){
                this.secondsLeft = Math.floor((this.endTime - fromTimeToCalc) / 1000);
                this.secondsLeft === 0 && this.finishAction === 'redirect' && this.handleRedirect();
            }

            this.writeToUnits(this.secondsLeft);
        },
        handleRedirect() {
            if(this.nodeIsLinked && this.linkTypesUsingAnchors.includes(this.getLinkType)) {
                window.location.href = this.createHrefForLink(this.getLinkData);
            }else {
                this.handleLinkSelection();
            }
        },
        writeToUnits(seconds) {
            // Iterate over shown units ONLY to carry over leftover time to next available unit
            for(let unit of this.filteredUnitsShown) {
                this.units[unit].value = Math.floor(seconds / this.units[unit].divisor);
                seconds -= this.units[unit].value * this.units[unit].divisor;
            }
        },
        saveVisitorData() {
            localStorage.setItem(`${this.pageData.id}_${this.componentId}_startTime`, this.startTime);
            localStorage.setItem(`${this.pageData.id}_${this.componentId}_endTime`, this.endTime);
        },
        loadVisitorData() {
            let savedStart = localStorage.getItem(`${this.pageData.id}_${this.componentId}_startTime`);
            this.setStartTime(savedStart ? new Date(savedStart) : newLocalizedDate());

            let savedEnd = localStorage.getItem(`${this.pageData.id}_${this.componentId}_endTime`);
            this.setEndTime(savedEnd ? new Date(savedEnd) : addMinutes(newLocalizedDate(), this.perVisitorMinutes));
        },
        isSingleDigit(unit) {
            return this.units[unit].value >= 0 && this.units[unit].value < 10;
        },
        previousTimerStyle() {
            const classList = this.timerStyleClass.includes("mini") ? this.miniTimerStyleClasses : this.timerStyleClasses

            let i = classList.findIndex(c => c === this.timerStyleClass);
            i = (i-1) < 0 ? classList.length-1 : i-1;
            this.setTimerStyleClass(classList[i]);
        },
        nextTimerStyle() {
            const classList = this.timerStyleClass.includes("mini") ? this.miniTimerStyleClasses : this.timerStyleClasses

            let i = classList.findIndex(c => c === this.timerStyleClass);
            i = (i+1) % classList.length;
            this.setTimerStyleClass(classList[i]);
        },

        // Alignment
        getAlignment () {
            let alignmentClass = this.alignmentClass;
            if (alignmentClass === "") {
                const justifyStyle =  this.getStyleProperty("justify-content", {}, this.$refs.cols);
                alignmentClass = justifyStyle === "flex-end" ? "j-c-fe" : justifyStyle === "center" ? "j-c-c" : "j-c-fs";
            }

            let classToAlignment = Object.keys(this.alignmentOptions).reduce( ( accum , key ) => {
                let currentIndexData = this.alignmentOptions[key];
                accum[currentIndexData.styleClass] = key;
                return accum;
            },{});

            return classToAlignment[alignmentClass];
        },
        updateAlignmentClass(newClass) {
            this.alignmentClass = newClass;
        },

        // Overridden LinksMixins (don't make it a clickable link)
        wrapNodeInAnchor() {},
        unwrapNodeFromAnchor() {},
        setAnchorAttributes() {},

        // Setters and getters
        getInitialTimerStyleClass() {
            return this.myNode?.dataset?.elementId ?? "timer1";
        },
        getTimerStyleClass() {
            return this.myData.timerStyleClass;
        },
        setTimerStyleClass(v) {
            this.changeMyData({timerStyleClass: v});
        },
        getTimerType() {
            return this.myData.timerType;
        },
        setTimerType(timerType) {
            this.changeMyData({timerType: timerType});
        },
        getUnitsShown() {
            return this.myData.unitsShown;
        },
        setUnitShown(unit, v) {
            let u = this.myData.unitsShown;
            u[unit] = v;
            this.changeMyData({unitsShown: u});
        },
        getStartTime(){
            return new Date(this.myData.startTime);
        },
        setStartTime(v) {
            this.changeMyData({startTime: new Date(v)});
        },
        getEndTime(){
            return new Date(this.myData.endTime);
        },
        setEndTime(v) {
            this.changeMyData({endTime: new Date(v)});
        },
        getPerVisitorMinutes() {
            return this.myData.perVisitorMinutes;
        },
        setPerVisitorMinutes(v) {
            this.changeMyData({perVisitorMinutes: v});
        },
        getFinishAction() {
            return this.myData.finishAction;
        },
        setFinishAction(v) {
            this.changeMyData({finishAction: v});
        },
        getMessage() {
            return this.myData.message;
        },
        setMessage(v) {
            this.changeMyData({message: v});
        },
        getHideIfInactive(){
            return this.myData.hideIfInactive;
        },
        setHideIfInactive(v) {
            this.changeMyData({hideIfInactive: v});
        },
    },
    created() {
        if (this.timerType === "visitorCountdown") {
            this.loadVisitorData(); // Either loads if exists or inits
            this.saveVisitorData(); // Save for next page load
        }
        this.timerTick(); // Don't flash zeroes
        this.registeredInterval = setInterval(this.timerTick, 1000);
    },
    beforeUpdate() {
        // To instantly update when changing props (not next timer tick)
        this.writeToUnits(this.secondsLeft);
    },
    beforeDestroy() {
        clearInterval(this.registeredInterval);
    },
    watch: {
        timerType() {
            if (this.timerType === "visitorCountdown") {
                this.loadVisitorData();
                this.timerTick();
            }
        },
        perVisitorMinutes() {
            if (this.timerType === "visitorCountdown") {
                this.loadVisitorData();
                this.timerTick();
            }
        },
    },
    filters: {
        capitalize(word) {
            return word ? word.charAt(0).toUpperCase() + word.slice(1) : '';
        }
    }
}
</script>